//Reselect selector

import { createSelector } from 'reselect';
import { setDefaultSource, getCountries } from '../../utils/helpers/costcenter';

import { getFilterCountries } from '../../utils/globalSelectors';

// Create select function to pick off the pieces of state we care about for this calculation

const getInsightsCostCenterSelector = state => state.common.costcenter;

const getInsightsCountrySelector = state => state.common.country;

const getInsightFiltersData = state => state.insights.insightFilters;

const getInsightsCCAndCountryProps = (costcenter, country, countries) => {
  return setDefaultSource(country, costcenter, countries);
};

const getDynamicFilterData = state => state.common.dynamicFilters;

const getRestrictionFilterSelector = dynamicFilters => {
  let restrictions = [];

  if (dynamicFilters && dynamicFilters.length > 0) {
    dynamicFilters.forEach(item => {
      if (item.value.length <= 0) return;

      restrictions.push({
        typeId: item.typeId,
        values: item.value.map(val => val.value),
      });
    });
  }

  return { restrictions };
};

export const getInsightsCCAndCountry = createSelector(
  getInsightsCostCenterSelector,
  getInsightsCountrySelector,
  getFilterCountries,
  getInsightsCCAndCountryProps
);

export const getInsightsDateFilter = createSelector(
  [getInsightFiltersData],
  getInsightFilters => {
    let dateFilter = [];
    dateFilter =
      getInsightFilters &&
      getInsightFilters.filter(item => item.filterType === 'Date');
    if (dateFilter && dateFilter.length) return dateFilter[0].filters;
    return [];
  }
);

export const getInsightsTabsFilter = createSelector(
  [getInsightFiltersData],
  getInsightFilters => {
    let tabFilter = [];
    tabFilter =
      getInsightFilters &&
      getInsightFilters.filter(item => item.filterType === 'Tabs');
    if (tabFilter && tabFilter.length) return tabFilter[0].filters;
    return [];
  }
);

export const getRestrictionFilter = createSelector(
  getDynamicFilterData,
  getRestrictionFilterSelector
);



// WEBPACK FOOTER //
// ./src/features/powerbi/selector.js